import { Button } from 'primereact/button'
import React from 'react'
import { useNavigate } from 'react-router-dom'

function LogoutModal({ onHideModal }) {
  const navigate= useNavigate()
  const handleLogout = () => {
    localStorage.clear();
    onHideModal()
    navigate('/')
    window.location.reload()

  }
  return (
      <>
          <p className="logout__heading">
              <span>
                  <i className="pi pi-sign-out mr-3"></i>
              </span>
              Logout
          </p>
          <p className="logout__text mb-4">Are you sure you want to logout?</p>
          <div className="flex mt-2 mb-2 justify-content-center">
              <Button label="Cancel" className="Btn__Transparent" style={{ width: '160px' }} onClick={() => onHideModal()} />
              <Button label="Logout" className="Btn__Send ml-2" style={{ width: '160px' }} onClick={() => handleLogout()} />
          </div>
      </>
  );
}

export default LogoutModal